import { render, staticRenderFns } from "./oaflow.vue?vue&type=template&id=1a560bbf&scoped=true"
import script from "./oaflow.vue?vue&type=script&lang=js"
export * from "./oaflow.vue?vue&type=script&lang=js"
import style0 from "./oaflow.vue?vue&type=style&index=0&id=1a560bbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a560bbf",
  null
  
)

export default component.exports